import { render } from "./inputCodeConfirmation.vue?vue&type=template&id=80d1d014&scoped=true&ts=true"
import script from "./inputCodeConfirmation.vue?vue&type=script&lang=ts"
export * from "./inputCodeConfirmation.vue?vue&type=script&lang=ts"

import "./inputCodeConfirmation.vue?vue&type=style&index=0&id=80d1d014&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d1d014"]])

export default __exports__